import React, {memo, FC, useState} from "react";
import moment from "moment";
import {Tag} from "antd";
import {BookedBy, BookingType, Currency, GetBookingsByCourseIdWithCourseLessonBookingsQuery} from "../../../../generated/graphql";
import {useCurrency} from "../../../../helpers/currencyHelper";
import {renderAmount} from "../../../../helpers/renderAmount";
import Button from "../../../../views/Button/Button";
import BookingDetails from "./BookingDetails";
import css from "./BookingDetails.less";

type BookingLineProps = {
    booking: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"][0];
};

// Teilnehmer und Bucher in einer Zeile (Variante A, 27.10.2026); Telefon, Anschrift und E-Mail stehen hinter „Details“.
const BookingLine: FC<BookingLineProps> = ({booking}) => {
    const [open, setOpen] = useState(false);
    const currency = useCurrency();
    const attendee = booking.attendee;
    const booker = attendee?.booker;
    const number = (prefix?: string | null, value?: number | string | null) => (value === null || value === undefined ? "" : ` (${prefix ?? ""}${value})`);
    const credit = booker?.credit ?? 0;

    return (
        <div className={css.bookingLine} data-testid="booking-line">
            <div className={css.bookingLineRow}>
                {attendee && (
                    <span className={css.bookingLineName}>
                        {`${attendee.firstname ?? ""} ${attendee.lastname ?? ""}`}
                        <span style={{fontWeight: 400, color: "rgba(0, 0, 0, 0.45)"}}>{number(attendee.customerNumberPrefix, attendee.customerNumber)}</span>
                    </span>
                )}
                {booker && <span>{`Bucher ${booker.firstname ?? ""} ${booker.lastname ?? ""}${number(booker.customerNumberPrefix, booker.customerNumber)}`}</span>}
                {booker && <span>{credit > 0 ? `Guthaben ${renderAmount({amount: credit, currency: currency.short as Currency})}` : "kein Guthaben"}</span>}
                {booking.bookingType === BookingType.Waitlist ? (
                    <Tag color="orange">{"Warteliste"}</Tag>
                ) : (
                    <Tag>{`${booking.bookedBy === BookedBy.Booker ? "Onlinebuchung" : "Buchung"} ${moment(booking.createDate).format("DD.MM.YYYY")}`}</Tag>
                )}
                <Button type="link" size="small" style={{marginLeft: "auto"}} onClick={() => setOpen((previous) => !previous)}>
                    {open ? "weniger" : "Details"}
                </Button>
            </div>
            {open && <BookingDetails booking={booking} />}
        </div>
    );
};

export default memo(BookingLine);
